import Stack from '@mui/material/Stack';
import React, { useEffect, useState } from 'react';
import { CreatedAudiosSection } from './CreatedAudiosSection';
import { Styles } from '@t2c/shared-fe';
import Box from '@mui/material/Box';
import {
  useAppContext,
  useDialog,
  useGetAllCreatedAudios,
  useGetPrivateAudios,
  useGetPublicAudios,
} from '../../hooks';
import { AudioStatus } from '../../@types';
import {
  FilteringSortingParams,
  MediaStatus,
  PAGE_DATA_LIMIT,
  REFETCH_INTERVAL,
} from '../../utils';
import { CreateActionCard } from '../../Common/card';
import { useRouter } from 'next/router';
import { FiltersAndSorting } from 'apps/t2c-fe/Common/FiltersAndSorting';
import { Button, Card, Divider, Typography, useMediaQuery, useTheme } from '@mui/material';
import { NextImage, useHistory } from '@sdf/base';
import { useSnackbar } from 'notistack';
import { TextToAudioWorkBench } from '../dashboard/ai-work-bench/TextToAudioWorkBench';

export const TextToSpeech = () => {
  const {
    isDialogOpen: openAudioBuildDialog,
    openDialog: handleOpenAudioDialog,
    closeDialog: closeAudioDialog,
  } = useDialog();

  const [params, setParams] = useState<FilteringSortingParams>({
    sortOrder: 'desc',
    limit: PAGE_DATA_LIMIT,
    sortBy: 'updatedAt',
  });

  const {
    data: createdTextToSpeechData,
    refetch: refetchTextToSpeechData,
    isLoading: isFetchingTextToSpeechData,
    fetchNextPage,
    hasNextPage,
  } = useGetAllCreatedAudios(params);

  const { textToSpeechContent, setTextToSpeechContent } = useAppContext();

  useEffect(() => {
    if (textToSpeechContent) {
      handleOpenAudioDialog();
    }
  }, [textToSpeechContent]);

  const { query } = useRouter();
  const { previousRoute } = useHistory();

  const theme = useTheme();
  const isExtraSmall = useMediaQuery(theme.breakpoints.down('sm'));

  useEffect(() => {
    if (query.action === 'create' && previousRoute === '/dashboard') handleOpenAudioDialog();
  }, [query]);

  const handleShowMore = () => {
    setParams({ ...params, limit: params.limit + 10 });
  };

  const filterOptions = [
    // {
    //   id: 1,
    //   name: 'Draft',
    //   value: MediaStatus.NotStarted,
    // },
    {
      id: 2,
      name: 'Generating',
      value: MediaStatus.InProgress,
    },
    {
      id: 3,
      name: 'Generated',
      value: MediaStatus.Success,
    },
    {
      id: 4,
      name: 'Failed',
      value: MediaStatus.Error,
    },
  ];

  const handleFilterOptionChange = (val: MediaStatus) => {
    setParams({ ...params, filters: { status: val } });
  };

  return (
    <Box sx={styles.container}>
      <Box sx={{
        ...styles.cardContainer, 
        borderWidth: isExtraSmall ? 'none' : '3px',
        padding: isExtraSmall ? 0 : '32px',
      }}>
        <Typography fontSize={24} fontWeight={500}>
          Audio Voiceover
        </Typography>

        {!isExtraSmall && (<Box sx={styles.subHeadingBox}>
          <Box>
            <NextImage
              src={'/assets/icons/ActiveVoiceoverMedia.svg'}
              alt=""
              width={39}
              height={24}
            />
          </Box>
          <Typography sx={styles.text}>
            Get professional voiceovers instantly. Provide your script, choose a voice, and let AI
            handle the rest.
          </Typography>
        </Box>)}

        <TextToAudioWorkBench refetchCreatedAudios={refetchTextToSpeechData} isPage={true} />
      </Box>
      <Box sx={styles.clipsSection}>
        <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 4 }}>
          <FiltersAndSorting
            params={params}
            setParams={setParams}
            filterArray={filterOptions}
            handleFilterOptionChange={handleFilterOptionChange}
          />
        </Box>
        <CreatedAudiosSection
          isDataLoading={isFetchingTextToSpeechData}
          data={createdTextToSpeechData}
          refetchTextToSpeechData={refetchTextToSpeechData}
          allAudios={true}
          fetchNextPage={fetchNextPage}
          hasNextPage={hasNextPage}
        />
      </Box>
    </Box>
  );
};

const styles: Styles = {
  container: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    width: '100%',
  },
  subHeadingBox: {
    display: 'flex',
    gap: 2,
    p: 2,
    backgroundColor: (theme) => theme.palette.background.activeCard,
    borderRadius: '6px',
    alignItems: 'center',
  },
  cardContainer: {
    padding: '32px',
    borderRadius: '16px',
    backgroundColor: (theme) => theme.palette.background.primary,
    width: '95%',
    display: 'flex',
    flexDirection: 'column',
    gap: 2,
    borderWidth: '3px',
    borderColor: (theme) => theme.palette.background.border,
  },
  clipsSection: {
    width: '95%',
    display: 'flex',
    flexDirection: 'column',
    gap: 2,
  },
  // cardContainer: {
  //   minHeight: 220,
  // },
  card: {
    p: 2,
    border: '2px solid',
    borderColor: (theme) => theme.palette.background.border,
    backgroundColor: (theme) => theme.palette.background.primary,
  },
};
